import { memo, useEffect, useState, useSyncExternalStore } from "react";
import WishlinkLoader from "WishlinkComponents/WishlinkLoader";
import WishlinkTypography from "WishlinkComponents/WishlinkTypography";
import { triggerGa } from "utils/gaUtils";
import {
  GA_ACTION,
  GA_CATEGORIES,
  GA_LABEL,
  GA_PAGE,
  GA_SCREEN_NAME,
} from "utils/constants";
import { isLoaderVisible, subscribeLoader } from "./loaderStore";
import "./LoaderRenderer.css";

const LOADER_TIMEOUT_MS = 15000;

/**
 * Singleton loader host. Mounted once at the app root and never
 * unmounted, so the loader SVG keeps one DOM node across all loading
 * gates (Firebase auth, creator config, Suspense chunks, page data)
 * and its CSS animation never restarts. LoadingPage instances only
 * toggle its visibility via the ref-counted loaderStore.
 */
const LoaderRenderer = () => {
  const visible = useSyncExternalStore(subscribeLoader, isLoaderVisible);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!visible) {
      setTimedOut(false);
      return undefined;
    }
    const timeoutId = setTimeout(() => {
      triggerGa({
        category: GA_CATEGORIES.LOADING,
        action: GA_ACTION.LOADER_TIMEOUT,
        label: GA_LABEL.LOADER_TIMEOUT_TEXT_SHOWN,
        page: GA_PAGE.LOADING,
        screenName: GA_SCREEN_NAME.LOADING,
      });
      setTimedOut(true);
    }, LOADER_TIMEOUT_MS);
    return () => clearTimeout(timeoutId);
  }, [visible]);

  return (
    <div className="wishlink-loader-host" data-visible={visible}>
      <WishlinkLoader scale={1.5} />
      {visible && timedOut && (
        <WishlinkTypography
          fontSize="0.75rem"
          fontWeight={400}
          color="#E38125"
          className="mt-8"
        >
          Stuck? Pull down to refresh or try reopening the app again.
        </WishlinkTypography>
      )}
    </div>
  );
};

export default memo(LoaderRenderer);
